import { CompanyLocationExceptionPreviewOutDTO } from '@api/ringil-api.v2';
import { dayjsFromApiUtcInTz, dayjsNowInTz, stringYMDFromDayjs } from '@utils/dateWithTz';

// Shared 30-day window so the header badge and the section table can never disagree.
// Window: [today, today+30) in the location timezone.
const WINDOW_DAYS = 30;

const ymdsOf = (row: CompanyLocationExceptionPreviewOutDTO, tz: string): string[] =>
  row.localDates && row.localDates.length > 0
    ? [...row.localDates].sort()
    : (row.dates ?? []).map(d => stringYMDFromDayjs(dayjsFromApiUtcInTz(d, tz))).sort();

export const matchingExceptionYmds = (row: CompanyLocationExceptionPreviewOutDTO, tz: string): string[] => {
  const fromYmd = stringYMDFromDayjs(dayjsNowInTz(tz));
  const toYmd = stringYMDFromDayjs(dayjsNowInTz(tz).add(WINDOW_DAYS, 'day'));
  return ymdsOf(row, tz).filter(d => d >= fromYmd && d < toYmd);
};

export const exceptionsInWindow = (
  exceptions: CompanyLocationExceptionPreviewOutDTO[] | undefined,
  tz: string,
): CompanyLocationExceptionPreviewOutDTO[] => (exceptions ?? []).filter(row => matchingExceptionYmds(row, tz).length > 0);
